import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFuelTypeList as getFuelTypeListApi,
	getFuelType as getFuelTypeApi,
	addNewFuelType as addNewFuelTypeApi,
	updateFuelType as updateFuelTypeApi,
	deleteFuelType as deleteFuelTypeApi,
} from '../../helpers/establishment/backend_helper';

export const getFuelTypeList = createAsyncThunk('fuelType/getFuelTypeList', async () => {
	try {
		const response = getFuelTypeListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFuelType = createAsyncThunk('fuelType/getFuelType', async fuelType_id => {
	try {
		const response = getFuelTypeApi(fuelType_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewFuelType = createAsyncThunk('fuelType/addNewFuelType', async fuelType => {
	try {
		const response = addNewFuelTypeApi(fuelType);
		toast.success('Tipo de Combustible agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar fuelType.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFuelType = createAsyncThunk('fuelType/updateFuelType', async (fuelType) => {
		try {
			const response = updateFuelTypeApi(fuelType);
			toast.success('Tipo de Combustible actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar fuelType.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFuelType = createAsyncThunk('fuelType/deleteFuelType', async fuelType => {
	try {
		const response = await deleteFuelTypeApi(fuelType);
		toast.success('Tipo de Combustible eliminado exitosamente.', { autoClose: 3000 });
		return { fuelType, ...response };
	} catch (error) {
		toast.error('Error al eliminar fuelType.', { autoClose: 3000 });
		throw new Error(error);
	}
});


